<script>
import MultiSelectHint from '@/components/ui/MultiSelectHint.vue'

export default {
  components: {
    'mia-multi-select-hint': MultiSelectHint
  },

  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    }
  },

  data: () => ({
    paymentMethods: [
      {
        id: 'cash',
        label: 'Barzahlung'
      },
      {
        id: 'leasing',
        label: 'Leasing'
      },
      {
        id: 'financing',
        label: 'Finanzierung'
      }
    ]
  }),

  created() {
  },

  methods: {
    onChange(event) {
      this.$emit('change', Array.from(event.target.selectedOptions).map(option => option.value))
    },

    isSelected(value) {
      return (Array.isArray(this.value) ? this.value : []).includes(value)
    }
  }
}
</script>

<template>
  <div>
    <label class="text-sm block mb-1 mr-2 tracking-wider text-gray-800">Zahlmethode</label>

    <select
      multiple
      class="w-full form-select"
      @change="onChange"
    >
      <option
        v-for="payMethod in paymentMethods"
        :key="payMethod.id"
        :value="payMethod.id"
        :selected="isSelected(payMethod.id)"
      >
        {{ payMethod.label }}
      </option>
    </select>

    <mia-multi-select-hint />
  </div>
</template>
